export default "__VITE_ASSET__ZkRydQJV__"